<template>
  <div class="task-new-dynamic">
    <DatePan @change="timeChange" v-model="timeArr" :shortcuts="shortcuts" :picker-options="pickerOptions"></DatePan>
    <ProjectList @change="projectChange"></ProjectList>
  </div>
</template>
<script>
import ProjectList from './projectList'
import DatePan from '@/components/taskFilterBox/date'
import { mapState } from 'vuex'
export default {
  props: [],
  components: {
    ProjectList,
    DatePan
  },
  computed: {
  },
  data() {
    return {
      timeArr: [],
      shortcuts: [{
        text: '清空',
        cellClassName:'date-cancel del-text text-red',
        onClick(picker) {
          picker.$emit('pick', '');
        }
      }],
      pickerOptions: {
        disabledDate(time) {
          // 获取当前日期
          const today = new Date();
          // 将今天之前的日期禁用
          return time.getTime() > today.getTime();
        }
      }
    }
  },
  methods: {
    timeChange(val) {
      this.$emit('timeChange', val)
    },
    projectChange(val) {
      this.$emit('projectChange', val)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-new-dynamic {
  display: flex;
  align-items: center;
  .fadeDown-enter-active {
    animation: fadeInUpBig 1s;
  }
  .fadeDown-leave-to {
    animation: fadeOutDownBig 1s;
  }
  .line {
    height: 16px;
    width: 1px;
    @include bgColorOpacity(.16);
    margin-left: 8px;
    margin-right: 16px;
  }
  .el-dropdown .el-dropdown-link {
    @include fontColorOpacity(.6);
    font-size: 14px;
    font-weight: 400;
    i {
      @include fontColorOpacity(.6);
      font-weight: 400;
      margin-right: 9px;
    }
  }
  .filter-status {
    margin-left: 9px;
  }
  .el-dropdown-link {
    padding:8px;
  }
}
</style>
